.badge {
  padding: 0 var(--space-1);
  border-radius: var(--radius-sm);
  background: var(--color-accent);
  color: var(--color-bg);
  font-size: var(--text-xs);
}

.note {
  flex-basis: 100%;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.subscribe {
  padding: 0;
  border: 0;
  background: none;
  color: var(--color-accent);
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
